import React, { useState } from 'react';
import KickImage from 'Reuseables/KickImage';
import classNames from 'classnames';
import { Button, Row, Col } from 'reactstrap';
import { Modal } from 'react-bootstrap';
import { hasError, convertToRupiah, getCloudImageUrl, formatRupiah } from '../../../utils';
import { RESOURCE_URL } from '../../../config';
import { FormFeedback } from '../../Forms';
import { FaCheckCircle } from 'react-icons/fa';
import { BsArrowLeftShort } from 'react-icons/bs';
import { IconContext } from 'react-icons';
const userBalanceIcon = `${RESOURCE_URL}icons/kickcredit.png`;
import ArrowPrev from "../../../images/arrow/luxury_prev.png";
import { PAYMENT_LOGOS } from '../../../constants/paymentMethods';
import Loading from '../../Loading';
import {
  BANKTRANSFER,
  VIRTUALACCOUNT,
  CREDITCARD,
  BCA_VA,
  BNI_VA,
  PERMATA_VA,
  MANDIRI_VA
} from '../../../constants/paymentMethods';

import CircleCloseButton from "../../../images/circle-close-button.png";
import BackButton from "../../../images/circle-back.png";
import ArrowDown from "../../../images/arrow-down-new.png";
import ArrowUp from "../../../images/arrow-up-new.png";
import RoundCloseButton from "../../../images/round-close-button.png";

const paymentMethods = [
  { value: BCA_VA, label: 'BCA Virtual Account', logo: PAYMENT_LOGOS.bca },
  { value: MANDIRI_VA, label: 'MANDIRI Virtual Account', logo: PAYMENT_LOGOS.mandiri },
  { value: BNI_VA, label: 'BNI Virtual Account', logo: PAYMENT_LOGOS.bni },
  { value: PERMATA_VA, label: 'PERMATA Virtual Account', logo: PAYMENT_LOGOS.permata },
  { value: VIRTUALACCOUNT, label: 'Other Virtual Account', logo: null },
];

const ModalPaymentTopUp = props => {
  const sellerPenalty = parseInt(props?.sellerPenalty ?? "0");
  const totalAmount = parseInt(props.amount) + parseInt(props.administrationFee);
  const totalReceive = parseInt(props?.amount ?? "0") - sellerPenalty;
  const [isOpenDetailInfo, setIsOpenDetailInfo] = useState(false)

  const toggleHandler = () => {
    if (props.isOpen) {
      props.deleteAllAmount()
    }
    props.onToggle()
  }

  return (
    <Modal
      className="modal-topup-v3"
      show={props.isOpen}
      onHide={props.onToggle}
    >
      <div id="topup-container">
        <KickImage onClick={toggleHandler} className='close-btn' src={RoundCloseButton} alt='close-btn' />
        <div className="topup-title">
          <div className='btn-wrapper' onClick={() => props.onNextPage(1)}>
            <KickImage src={BackButton} alt='back-btn' />
          </div>
          <span>Top Up</span>
        </div>
        <div className='scrollable-wrapper'>
          <div className="topup-content">
            <div className="topup-header">
              <div className="topup-payment-info">
                <div className="amount-info">
                  <span>Amount to be paid</span>
                  <span>IDR {convertToRupiah(parseInt(totalAmount))}</span>
                </div>
                <div onClick={() => setIsOpenDetailInfo(!isOpenDetailInfo)} className='info-details'>
                  <p>{isOpenDetailInfo ? "Hide" : "View"} details</p>
                  <KickImage src={isOpenDetailInfo ? ArrowUp : ArrowDown} alt='detail-arrow' />
                </div>
              </div>
              {
                isOpenDetailInfo ?
                  <div className={`details-info-wrapper`}>
                    <div className='details-section'>
                      <div className='sub-section'>
                        <p>Top Up details</p>
                      </div>
                      <div className='sub-section'>
                        <p>Top up amount</p>
                        <p>IDR {convertToRupiah(parseInt(props.amount))}</p>
                      </div>
                      <div className='sub-section'>
                        <p>Top up fee</p>
                        <p>IDR {convertToRupiah(parseInt(props.administrationFee))}</p>
                      </div>
                    </div>
                    <div className='details-section tobe-paid'>
                      <div className='sub-section'>
                        <p>Amount to be paid</p>
                        <p>IDR {convertToRupiah(parseInt(totalAmount))}</p>
                      </div>
                    </div>
                  </div>
                  : null
              }
            </div>
            <div className="topup-payment-method">
              <div className="payment-method-header">
                <span>Choose payment method</span>
              </div>
              {
                paymentMethods.map((v, i) => {
                  const paymentValidate = v.value === props.paymentMethod;
                  return (
                    <div key={v.value} className="payment-method-info">
                      <div
                        className="payment-method-value"
                        onClick={() => props.onTextChange("_paymentMethod", v.value)}
                      >
                        {v.logo ? <div className="icon-wrapper">
                          {v.logo ? <KickImage src={getCloudImageUrl(v.logo)} alt="..." /> : null}
                        </div> : null}
                        <div className="payment-label">
                          <span>{v.label}</span>
                        </div>
                        <div className="payment-check">
                          {
                            paymentValidate ?
                              <IconContext.Provider value={{ color: '#159953', size: '20px' }}>
                                <FaCheckCircle />
                              </IconContext.Provider>
                              :
                              <input
                                className="topup-radio-check"
                                value={props.paymentMethod}
                                type="radio"
                                checked={paymentValidate}
                                onChange={() => props.onTextChange("_paymentMethod", v.value)}
                              />
                          }
                        </div>
                      </div>
                    </div>
                  );
                })
              }
            </div>
          </div>
        </div>
        <div className="topup-button">
          {
            props.isSubmit || props.isRedirect ?
              <Loading center />
              :
              <Button
                className="topup-content"
                onClick={props.onSubmit}
              >
                Confirm
              </Button>
          }
        </div>
      </div>
    </Modal>
  )
}

export default ModalPaymentTopUp;